"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_vm.list.length > 0 ? _c("div", {
    staticClass: "notification-list"
  }, _vm._l(_vm.list, function (notification, index) {
    return _c("div", {
      key: index,
      class: "notification-item" + (notification.isRead ? "" : " unread"),
      on: {
        click: function ($event) {
          return _vm.markNotificationRead(notification);
        }
      }
    }, [_c("div", {
      staticClass: "notification-content"
    }, [_c("strong", {
      staticClass: "notification-title"
    }, [_vm._v(_vm._s(notification.title))]), _c("p", {
      staticClass: "notification-body"
    }, [_vm._v(" " + _vm._s(notification.message) + " ")])]), _c("i", {
      staticClass: "el-icon-arrow-right notification-right-icon"
    })]);
  }), 0) : _c("div", {
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px"
    }
  }, [_vm._v(" No notifications found. ")]), _c("pagination", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.total > 0,
      expression: "total > 0"
    }],
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;